"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPlainImplementationKindMap = exports.isCredentialImplementationKind = exports.isAssistedImplementationKind = exports.isSandboxImplementationKind = exports.isApiImplementationKind = exports.ConnectionAccountType = exports.ImplementationKind = exports.Category = exports.States = void 0;
exports.States = {
    SIGN_IN: 'SIGN_IN',
    REAUTH: 'REAUTH',
    CHOOSE_ACCOUNT: 'CHOOSE_ACCOUNT',
};
var Category;
(function (Category) {
    Category["HRIS"] = "hris";
})(Category || (exports.Category = Category = {}));
var ImplementationKind;
(function (ImplementationKind) {
    ImplementationKind["API_TOKEN"] = "api_token";
    ImplementationKind["OAUTH"] = "oauth";
    ImplementationKind["CREDENTIAL"] = "credential";
    ImplementationKind["ASSISTED"] = "assisted";
    ImplementationKind["FINCH_SANDBOX_API_TOKEN"] = "finch_sandbox_api_token";
    ImplementationKind["FINCH_SANDBOX_OAUTH"] = "finch_sandbox_oauth";
    ImplementationKind["FINCH_SANDBOX_CREDENTIAL"] = "finch_sandbox_credential";
    ImplementationKind["FINCH_SANDBOX_ASSISTED"] = "finch_sandbox_assisted";
})(ImplementationKind || (exports.ImplementationKind = ImplementationKind = {}));
var ConnectionAccountType;
(function (ConnectionAccountType) {
    ConnectionAccountType["AUTOMATED"] = "automated";
    ConnectionAccountType["AUTOMATED_AND_ASSISTED"] = "automated_and_assisted";
    ConnectionAccountType["ASSISTED"] = "assisted";
})(ConnectionAccountType || (exports.ConnectionAccountType = ConnectionAccountType = {}));
const isApiImplementationKind = (kind) => kind === ImplementationKind.OAUTH ||
    kind === ImplementationKind.API_TOKEN ||
    kind === ImplementationKind.FINCH_SANDBOX_OAUTH ||
    kind === ImplementationKind.FINCH_SANDBOX_API_TOKEN;
exports.isApiImplementationKind = isApiImplementationKind;
const isSandboxImplementationKind = (kind) => kind.startsWith('finch_sandbox_');
exports.isSandboxImplementationKind = isSandboxImplementationKind;
const isAssistedImplementationKind = (kind) => kind === ImplementationKind.ASSISTED ||
    kind === ImplementationKind.FINCH_SANDBOX_ASSISTED;
exports.isAssistedImplementationKind = isAssistedImplementationKind;
const isCredentialImplementationKind = (kind) => kind === ImplementationKind.CREDENTIAL ||
    kind === ImplementationKind.FINCH_SANDBOX_CREDENTIAL;
exports.isCredentialImplementationKind = isCredentialImplementationKind;
exports.toPlainImplementationKindMap = {
    [ImplementationKind.CREDENTIAL]: ImplementationKind.CREDENTIAL,
    [ImplementationKind.API_TOKEN]: ImplementationKind.API_TOKEN,
    [ImplementationKind.OAUTH]: ImplementationKind.OAUTH,
    [ImplementationKind.ASSISTED]: ImplementationKind.ASSISTED,
    [ImplementationKind.FINCH_SANDBOX_CREDENTIAL]: ImplementationKind.CREDENTIAL,
    [ImplementationKind.FINCH_SANDBOX_API_TOKEN]: ImplementationKind.API_TOKEN,
    [ImplementationKind.FINCH_SANDBOX_OAUTH]: ImplementationKind.OAUTH,
    [ImplementationKind.FINCH_SANDBOX_ASSISTED]: ImplementationKind.ASSISTED,
};
